import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ariadni_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 401 response interceptor: attempt silent token refresh, then sign out on failure.
let refreshPromise = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 401 && !orig._retry && !orig.url?.includes("/auth/")) {
      orig._retry = true;
      const refresh = localStorage.getItem("ariadni_refresh");
      if (refresh) {
        try {
          if (!refreshPromise) {
            refreshPromise = api.post("/auth/refresh", { refresh_token: refresh })
              .then(({ data }) => {
                localStorage.setItem("ariadni_token", data.token);
                if (data.refresh_token) localStorage.setItem("ariadni_refresh", data.refresh_token);
                return data.token;
              })
              .finally(() => { refreshPromise = null; });
          }
          const newToken = await refreshPromise;
          orig.headers.Authorization = `Bearer ${newToken}`;
          return api(orig);
        } catch {
          localStorage.removeItem("ariadni_token");
          localStorage.removeItem("ariadni_refresh");
          window.location.href = "/login";
          return Promise.reject(error);
        }
      }
      localStorage.removeItem("ariadni_token");
      localStorage.removeItem("ariadni_refresh");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Turn a stored image reference into a fully-qualified URL.
export const resolveImg = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

export const vcardUrl = (slug) => `${API_BASE}/cards/${slug}/vcard`;
export const qrUrl = (slug) => `${API_BASE}/cards/${slug}/qr`;
export const posterUrl = (slug) => `${API_BASE}/cards/${slug}/poster`;
export const appleWalletUrl = (slug) => `${API_BASE}/cards/${slug}/wallet/apple/download`;

// Phase P: stable idempotency key per logical submission (retry-safe public writes).
export const newIdemKey = () => (typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
export const idem = (key) => ({ headers: { "Idempotency-Key": key } });
